import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";

const TopNav = () => {
  const [topNavTitle, setTopNavTitle] = useState({});

  const allTopNavTitle = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/extra-contents/get-all-contents`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setTopNavTitle(response.data[0] || {});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    allTopNavTitle();
  }, []);

  // Convert URLs inside the text into clickable links
  const renderTextWithLinks = (text) => {
    if (!text) return null;

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
      if (/^https?:\/\//i.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-300"
          >
            {part}
          </a>
        );
      }

      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  };

  return (
    <div className="hidden sm:block w-full z-50 text-white shadow-md bg-gradient-to-r from-[#460300] to-[#141417] text-center font-subheading text-xs tracking-wider px-4 md:px-8 lg:px-12 py-2">
      {renderTextWithLinks(topNavTitle?.topNavTitle)}
    </div>
  );
};

export default TopNav;